import React, { useEffect } from 'react';
import { AgreeDisagreeButtonProps } from './config';
import Cookies from 'js-cookie';
import './styles.scss';

const AgreeDisagreeButton = ({
  buttontype1,
  buttontext1,
  openinanewtab1,
  buttontext2,
  buttonurl2,
  openinanewtab2,
}: AgreeDisagreeButtonProps) => {
  useEffect(() => {
    if (window.grunticon) {
      window.grunticon.embedIcons(
        window.grunticon.getIcons(window.grunticon.getCSS(window.grunticon.href))
      );
    }
  }, []);
  const handleAgreeClick = (e: any) => {
    e.preventDefault();
    const cookieName = 'TU_DISCLAIMER',
      cookieValue = 'agreed',
      cookieVal = Cookies.get(cookieName);
    if (typeof cookieVal == 'undefined' || cookieVal !== cookieValue) {
      const redirectCookieName = 'TU_DISCLAIMER_REDIRECT',
        redirectCookieVal = Cookies.get(redirectCookieName);
      Cookies.set(cookieName, cookieValue, { expires: 1 });
      Cookies.remove(redirectCookieName);
      window.location.replace(redirectCookieVal!);
    }
  };
  return (
    <div className="tu-agree-disagree-button">
      <div className="module module--rich-text module--flat-top">
        <div className="module__content l-padding">
          <div className="rich-text ">
            <div className="btn-container">
              <a
                href="!#"
                className={`btn ${buttontype1}`}
                onClick={(e) => handleAgreeClick(e)}
              >
                {buttontext1}{' '}
                <span
                  className="icon icon--arrow-right"
                  data-grunticon-embed="true"
                ></span>
              </a>
              <div>
                <a
                  href={buttonurl2}
                  target={openinanewtab2 ? '_blank' : ''}
                  className="btn btn--link fn_disagree-btn"
                  rel="noreferrer"
                >
                  {buttontext2}{' '}
                  <span
                    className="icon icon--arrow-right"
                    data-grunticon-embed="true"
                  ></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgreeDisagreeButton;
